import React from 'react';

const BloodPressureStats = ({ dateRange, entries }) => {
  // Calculate blood pressure stats
  const bpEntries = entries
    .filter(entry => entry.type === 'bloodPressure')
    .filter(entry => {
      if (!dateRange.start && !dateRange.end) return true;
      
      const entryDate = new Date(entry.datetime);
      const startDate = dateRange.start ? new Date(dateRange.start) : null;
      const endDate = dateRange.end ? new Date(dateRange.end) : null;
      
      if (startDate) startDate.setHours(0, 0, 0, 0);
      if (endDate) endDate.setHours(23, 59, 59, 999);
      
      if (startDate && entryDate < startDate) return false;
      if (endDate && entryDate > endDate) return false;
      return true;
    });

  if (bpEntries.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow p-2 sm:p-4 border border-blue-100">
        <h4 className="text-sm sm:font-medium text-gray-800 mb-1 sm:mb-2">Average Blood Pressure</h4>
        <div className="text-gray-600 text-xs sm:text-sm">No readings available</div>
      </div>
    );
  }

  const validReadings = bpEntries
    .map(entry => {
      const [systolic, diastolic] = entry.value.split('/').map(v => parseInt(v.trim()));
      return { systolic: systolic || 0, diastolic: diastolic || 0 };
    })
    .filter(reading => reading.systolic > 0 && reading.diastolic > 0);

  if (validReadings.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow p-2 sm:p-4 border border-blue-100">
        <h4 className="text-sm sm:font-medium text-gray-800 mb-1 sm:mb-2">Average Blood Pressure</h4>
        <div className="text-gray-600 text-xs sm:text-sm">No readings available</div>
      </div>
    );
  }

  const avgSystolic = validReadings.reduce((sum, reading) => sum + reading.systolic, 0) / validReadings.length;
  const avgDiastolic = validReadings.reduce((sum, reading) => sum + reading.diastolic, 0) / validReadings.length;

  return (
    <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow p-2 sm:p-4 border border-blue-100">
      <h4 className="text-sm sm:font-medium text-gray-800 mb-1 sm:mb-2">Average Blood Pressure</h4>
      <div>
        <div className="text-lg sm:text-2xl font-bold text-teal-700 mb-1">
          {Math.round(avgSystolic)}/{Math.round(avgDiastolic)}
          <span className="text-xs sm:text-base font-normal text-teal-600 ml-1">mmHg</span>
        </div>
        <div className="text-xs text-gray-500 mt-1">
          {validReadings.length} readings
        </div>
      </div>
    </div>
  );
};

export default BloodPressureStats;
